import React from "react";

const EmailIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="email_icon"
      data-name="email"
      {...props}
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6666 3.33331H4.99992C4.08075 3.33331 3.33325 4.08081 3.33325 4.99998V9.16665H4.99992V6.66665L10.3333 10.6666C10.4776 10.7747 10.653 10.8331 10.8333 10.8331C11.0135 10.8331 11.189 10.7747 11.3333 10.6666L16.6666 6.66665V14.1666H9.99992V15.8333H16.6666C17.5858 15.8333 18.3333 15.0858 18.3333 14.1666V4.99998C18.3333 4.08081 17.5858 3.33331 16.6666 3.33331ZM10.8333 8.95831L5.55492 4.99998H16.1116L10.8333 8.95831Z"
        fill={props.fill || "#0E426D"}
      />
      <path
        d="M1.66675 10H7.50008V11.6667H1.66675V10ZM3.33341 12.5H8.33342V14.1667H3.33341V12.5ZM5.83341 15H9.16675V16.6667H5.83341V15Z"
        fill={props.fill || "#0E426D"}
      />
    </svg>
  );
};

export default EmailIcon;
